import React from 'react';
import Head from 'next/head'
import { get } from "lodash";
import { ContentfulApi } from '../../api/ContentfulApi';
import Breadcrumb from "../../components/Breadcrumb";
import { getServerSideLocaleData } from "../../utils/server-side/getLocaleData";
import TermsTemplate from "../../components/Terms/TermsTemplate/TermsTemplate";

const PrivacyPolicy = ({ terms, californiaTerms, redirectUrl }) => {
    const showTerms = !!terms;
    const showCaliforniaTerms = !!californiaTerms;
    const showBreadcrumb = showTerms || showCaliforniaTerms;
    return (
        <div>
            <Head>
                <title>Peerspace</title>
                <link rel="icon" href="https://assets.peerspace.com/peerspace_favicon-196x196.png?v=rb" />
            </Head>
            <div className="container pt-10">
                {showBreadcrumb && <Breadcrumb breadCrumbLinks={terms.breadCrumbLinks} redirectUrl={redirectUrl} />}
                {showTerms &&
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <TermsTemplate {...terms} />
                            </div>
                        </div>
                    </div>
                }
                {showCaliforniaTerms &&
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <TermsTemplate {...californiaTerms} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export const getServerSideProps = async (context) => {
    const localeProps = await getServerSideLocaleData(context);
    const locale = get(localeProps ,'locale', 'en-US');
    const termsData = await ContentfulApi.getPrivacyPolicy(locale);
    const californiaTermsData = await ContentfulApi.getCaliforniaPolicy(locale);
    return {
        props: {
            ...localeProps,
            redirectUrl: 'legal/privacy',
            terms: termsData,
            californiaTerms: californiaTermsData
        }
    }
}

export default PrivacyPolicy;
